import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

function DataScreen() {
  var trollies = 0;
  var trollers = 0;
  var trucks = 0;
  var cart = 0;
  var pickUps = 0;
  var miniTrucks = 0;
  var tractorCarts = 0;

  // State for API data
  const [dataA, setDataA] = useState([]);
  const [dataB, setDataB] = useState([]);
  const [dataC, setDataC] = useState([]);
  const [dataD, setDataD] = useState([]);

  // Loading state
  const [loadingA, setLoadingA] = useState(true);
  const [loadingB, setLoadingB] = useState(true);
  const [loadingC, setLoadingC] = useState(true);
  const [loadingD, setLoadingD] = useState(true);

  // Error state
  const [errorA, setErrorA] = useState(null);
  const [errorB, setErrorB] = useState(null);
  const [errorC, setErrorC] = useState(null);
  const [errorD, setErrorD] = useState(null);

  // Active menu state for sidebar
  const [activeMenu, setActiveMenu] = useState("");

  useEffect(() => {
    // Fetch data for Class A (1st API)
    const fetchDataA = async () => {
      try {
        const response = await fetch(
          "https://webcore.hunzagroupofindustries.com.pk/api/LoadSummary"
        );
        if (!response.ok) throw new Error("Failed to fetch data for Class A");
        const result = await response.json();
        setDataA(result);
      } catch (error) {
        setErrorA(error.message);
      } finally {
        setLoadingA(false);
      }
    };

    // Fetch data for Class B (2nd API)
    const fetchDataB = async () => {
      try {
        const response = await fetch("https://webcore.hunzagroupofindustries.com.pk/api/OYardAG");
        if (!response.ok) throw new Error("Failed to fetch data for Class B");
        const result = await response.json();
        setDataB(result);
      } catch (error) {
        setErrorB(error.message);
      } finally {
        setLoadingB(false);
      }
    };

    // Fetch data for Class C (3rd API)
    const fetchDataC = async () => {
      try {
        const response = await fetch("https://webcore.hunzagroupofindustries.com.pk/api/InYardAG");
        if (!response.ok) throw new Error("Failed to fetch data for Class C");
        const result = await response.json();
        setDataC(result);
      } catch (error) {
        setErrorC(error.message);
      } finally {
        setLoadingC(false);
      }
    };
    // Fetch data for Class C (3rd API)
    const fetchDataD = async () => {
      try {
        const response = await fetch("https://webcore.hunzagroupofindustries.com.pk/api/Circle");
        if (!response.ok) throw new Error("Failed to fetch data for Class C");
        const result = await response.json();
        setDataD(result);
      } catch (error) {
        setErrorD(error.message);
      } finally {
        setLoadingD(false);
      }
    };

    // Call the fetch functions
    fetchDataD();
    fetchDataC();
    fetchDataB();
    fetchDataA();
  }, []);

  const inYard = parseFloat(dataC[0]?.InYard) || 0;
  const outYard = parseFloat(dataB[0]?.OutYard) || 0;
  const totalYard = inYard + outYard;

  // setting value
  trollies = dataA[0]?.Trollies;
  trollers = dataA[0]?.Trollers;
  trucks = dataA[0]?.Trucks;
  cart = dataA[0]?.Carts;
  pickUps = dataA[0]?.PickUps;
  miniTrucks = dataA[0]?.MiniTrucks;
  tractorCarts = dataA[0]?.TractorCarts;

  const loadsummary =
    trollies + trollers + trucks + cart + pickUps + miniTrucks + tractorCarts;

  return (
    <div className="container ">
      {/* Sidebar */}

      {/* Main Content Area */}
      <main className="flex-grow-1 p-4" style={{ backgroundColor: "#f8f9fa" }}>
        <h2 className="text-center mb-4 ">Yard Balance</h2>

        {/* Class B Data (2nd API) */}
        <div className="row">
          <div className="col-md-4">
            <div className="card">
              <div className="card-header bg-success text-white">
                <h4>Yard Summary</h4>
              </div>
              <div className="card-body">
                {loadingB && <div>Loading data for Class B...</div>}
                {errorB && <div className="alert alert-danger">{errorB}</div>}
                {dataB.length > 0 && !loadingB && (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Yard </th>
                          <th className="text-end">Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>In Yard</td>
                          <td className="text-end">
                            {dataC[0]?.InYard || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td>Out Yard</td>
                          <td className="text-end">
                            {dataB[0]?.OutYard || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Total </strong>
                          </td>
                          <td className="text-end">{totalYard}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
                {!dataB.length && !loadingB && <div>No data available</div>}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h4>Haulage Wise Yard Balance</h4>
              </div>
              <div className="card-body">
                {loadingA && <div>Loading data for Class A...</div>}
                {errorA && <div className="alert alert-danger">{errorA}</div>}
                {dataA.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Haulage Type</th>
                          <th className="text-end">Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Trollies</td>
                          <td className="text-end">{trollies}</td>
                        </tr>
                        <tr>
                          <td>Trollers</td>
                          <td className="text-end">{trollers}</td>
                        </tr>
                        <tr>
                          <td>Trucks</td>
                          <td className="text-end">{trucks}</td>
                        </tr>
                        <tr>
                          <td>Cart</td>
                          <td className="text-end">{cart}</td>
                        </tr>
                        <tr>
                          <td>PickUps</td>
                          <td className="text-end">{pickUps}</td>
                        </tr>
                        <tr>
                          <td>MiniTrucks</td>
                          <td className="text-end">{miniTrucks}</td>
                        </tr>
                        <tr>
                          <td>TractorCarts</td>
                          <td className="text-end">{tractorCarts}</td>
                        </tr>
                        <tr>
                          <td>Total</td>
                          <td className="text-end">{loadsummary}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div>No data available</div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-header bg-danger text-white">
                <h4>Circle Wise Yard Balance</h4>
              </div>
              <div className="card-body">
                {loadingD && <div>Loading data for Class D...</div>}
                {errorD && <div className="alert alert-danger">{errorD}</div>}
                {dataD && dataD.length > 0 && !loadingB && (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Circle Name</th>
                          <th className="text-end">InYard</th>
                          <th className="text-end">OutYard</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Iterating over each item in dataD */}
                        {dataD.map((item, index) => (
                          <tr key={index}>
                            <td>{item.Circle || "N/A"}</td>
                            <td className="text-end">
                              {item.INYARD !== undefined ? item.INYARD : "N/A"}
                            </td>
                            <td className="text-end">
                              {item.OUTYARD !== undefined
                                ? item.OUTYARD
                                : "N/A"}
                            </td>
                          </tr>
                        ))}
                        {/* Total Row */}
                        <tr>
                          <td>
                            <strong>Total</strong>
                          </td>
                          <td className="text-end">
                            {/* Sum INYARD and OUTYARD for all rows */}
                            {dataD.reduce(
                              (acc, item) => acc + (item.INYARD || 0),
                              0
                            )}
                          </td>
                          <td className="text-end">
                            {dataD.reduce(
                              (acc, item) => acc + (item.OUTYARD || 0),
                              0
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
                {!dataD.length && !loadingB && <div>No data available</div>}
              </div>
            </div>
          </div>
        </div>

        {/* Class A Data (1st API) */}
        <div className="row"></div>
      </main>
    </div>
  );
}

export default DataScreen;
